import { render, staticRenderFns } from "./jxsUserAgreement.vue?vue&type=template&id=551ca482&scoped=true"
import script from "./jxsUserAgreement.vue?vue&type=script&lang=js"
export * from "./jxsUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./jxsUserAgreement.vue?vue&type=style&index=0&id=551ca482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ca482",
  null
  
)

export default component.exports